<template>
  <div
    class="position-relative img-container"
    style=""
  >
    <img
      :src="`/images/cycle_dashboard_icon_${cycle.started ? cycle.is_current? 'white': 'blue' : 'gray'}.svg`"
      class="position-absolute"
    >
    <span
      class=" position-absolute"
      :class="{
        'theme--text' : cycle.started
      }"
      style=""
    >
      {{ cycle.order }}
    </span>
  </div>
</template>

<script>
export default {
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    }
}
</script>

<style lang="scss" scoped>
.img-container {
  @media screen and (min-width: 768px) {
    width: 40px;
    height: 40px;
  }
  width:23px;
  height:23px;
  img {
    @media screen and (min-width: 768px) {
      width: 40px;
      height: 40px;
    }
    width: 23px;
    height: 23px;
  }
  span {
    @media screen and (min-width: 768px) {
      font-size: 14px; 
      top: 19px; 
      left: 25px;
    }
    top: 11px; 
    left: 14px;
    font-size: 9px; 
    font-weight: bold; 
    
  }
}
</style>>

